<script setup>
import { computed, ref } from 'vue';

const QUICKSETS = [
    { amount: 4000, label: 'Kolczyki / prezent' },
    { amount: 8000, label: 'Naszyjnik' },
    { amount: 12000, label: 'Pierścionek' },
    { amount: 18000, label: 'Bransoletka tenisowa' },
    { amount: 30000, label: 'Pierścionek + obrączki' },
];

const amount = ref(0);

const formatNumber = (n) => Number(n).toLocaleString('pl-PL').replace(/,/g, ' ');

const tier = computed(() => {
    const a = amount.value;
    if (a === 0) return { name: 'Przed pierwszym zakupem', discount: 0, level: 'pre' };
    if (a < 10000) return { name: 'Poziom Silver', discount: 0, level: 'silver' };
    if (a < 25000) return { name: 'Poziom Gold', discount: 5, level: 'gold' };
    if (a < 65000) return { name: 'Poziom Platinum', discount: 10, level: 'platinum' };
    return { name: 'Poziom Black', discount: 15, level: 'black' };
});

const formattedAmount = computed(() => formatNumber(amount.value));

const resultText = computed(() => {
    const t = tier.value;
    if (t.level === 'pre') {
        return 'Tu zaczyna się Twoja droga w MySAVICKI. Każdy zakup będzie sumował się do Twojego poziomu, bez limitu czasu.';
    }
    if (t.discount === 0) {
        return 'Już dziś masz <strong class="accent-text">wcześniejszy dostęp do nowych kolekcji</strong> i ofert wyłącznych. Twój zakup zaczyna budować Twój poziom, bez limitu czasu.';
    }
    return `Każdy następny zakup będzie dla Ciebie o <strong class="accent-text">${t.discount}% tańszy</strong>, również wtedy, kiedy jest już w promocji.`;
});

const exampleText = computed(() => {
    const t = tier.value;
    if (t.level === 'pre') {
        return '<strong>Wskazówka:</strong> przesuń suwak lub wybierz jedną z propozycji, żeby zobaczyć jak Twój zakup buduje korzyści członkowskie.';
    }
    if (t.discount === 0) {
        const need = 10000 - amount.value;
        return `<strong>Kolejne ${formatNumber(need)} zł</strong> wydane w SAVICKI odblokuje Ci stały rabat 5%, również od cen w promocji.`;
    }
    const examplePrice = 10000 * (1 - t.discount / 100);
    return `<strong>Przykład:</strong> kolejna biżuteria za 10 000 zł będzie Cię kosztować <strong>${formatNumber(examplePrice)} zł</strong>.`;
});

const setAmount = (value) => {
    amount.value = value;
};
</script>

<template>
    <div class="ms-calc-widget">
        <div class="ms-calc-input-block">
            <div class="ms-calc-label">Wartość Twoich zakupów w SAVICKI</div>
            <div class="ms-calc-amount">
                <span>{{ formattedAmount }}</span><span class="ms-calc-amount-unit">zł</span>
            </div>
            <div class="ms-slider-container">
                <input
                    v-model.number="amount"
                    type="range"
                    min="0"
                    max="100000"
                    step="1000"
                    class="ms-slider"
                    aria-label="Wartość zakupów"
                />
                <div class="ms-slider-range">
                    <span>0 zł</span>
                    <span>100 000 zł+</span>
                </div>
            </div>
            <div class="ms-calc-quickset">
                <button
                    v-for="quick in QUICKSETS"
                    :key="quick.amount"
                    class="ms-calc-quickset-btn"
                    type="button"
                    @click="setAmount(quick.amount)"
                >
                    {{ quick.label }}
                </button>
            </div>
        </div>
        <div class="ms-calc-output-block">
            <div class="ms-calc-result-label">Twój rabat na każdy kolejny zakup</div>
            <Transition name="ms-tier" mode="out-in">
                <div :key="tier.level" class="ms-calc-output-content">
                    <div class="ms-calc-result-tier">{{ tier.name }}</div>
                    <div class="ms-calc-result-discount"><span>{{ tier.discount }}</span>%</div>
                    <div class="ms-calc-result-discount-label" v-html="resultText"></div>
                    <div class="ms-calc-example" v-html="exampleText"></div>
                </div>
            </Transition>
        </div>
    </div>
</template>
